export default "__VITE_ASSET__0c96717d__"